import { render } from "./SidebarCard.vue?vue&type=template&id=96136170"
import script from "./SidebarCard.vue?vue&type=script&lang=js"
export * from "./SidebarCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__